
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 200 200"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M110.5 131c7.732 0 14 6.268 14 14s-6.268 14-14 14h-73c-7.732 0-14-6.268-14-14s6.268-14 14-14h73zM37 87h126c7.732 0 14 6.268 14 14s-6.268 14-14 14H37c-7.732 0-14-6.268-14-14s6.268-14 14-14zm126-44c7.732 0 14 6.268 14 14s-6.268 14-14 14H37c-7.732 0-14-6.268-14-14s6.268-14 14-14h126z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    